import { createMuiTheme } from '@material-ui/core'
import { themeConstructor } from './themeConstructor'
import { bluePalette as palette } from '../palettes'

export const blueTheme = createMuiTheme({
  ...themeConstructor(palette), // default theme
  palette, // override color schema
})
